import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[inputDisplay]',
})
export class InputDisplayDirective {
  constructor(public template: TemplateRef<any>) {
  }
}
